import {
    Alert,
    Button,
    Divider, Popconfirm,
    Spin,
    Table,
} from "antd";
import {
    LeftOutlined,
    EditOutlined,
    DeleteOutlined,
} from "@ant-design/icons";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {deleteById, getAllRules} from "../../http/BonusRuleApi";
import {ADD_BONUS_RULE_ROUTE, EDIT_BONUS_RULE_ROUTE} from "../../utils";

export default function BonusRules() {
    const navigate = useNavigate();
    const goBack = () => navigate(-1);
    const [loading, setLoading] = useState(false);
    const [rules, setRules] = useState([]);
    const [alertSuccessVisible, setAlertSuccessVisible] = useState(false);
    const [alertErrorVisible, setAlertErrorVisible] = useState(false);

    const rulesColumns = [
        {
            title: 'Название',
            dataIndex: 'name',
            key: 'name',
        },
        {
            dataIndex: 'actions',
            key: 'actions',
            align: 'left',
        },
    ];

    const getRules = async () => {
        setLoading(true);
        await getAllRules(localStorage.getItem('token')).then(
            response => {
                setRules(
                    response.data.map(row => ({
                        key: row.id,
                        name: row.name,
                        actions: <>
                            <Button icon={<EditOutlined/>}
                                    style={{
                                        marginRight: '1vw',
                                    }}
                                    onClick={() => navigate(`${EDIT_BONUS_RULE_ROUTE}/${row.id}`)}></Button>
                            {row.id !== 1 ?
                                <Popconfirm
                                    title="Удалить набор?"
                                    onConfirm={() => deleteRule(row.id)}
                                    okText="Да"
                                    cancelText="Нет"
                                >
                                    <Button type="primary" danger icon={<DeleteOutlined/>}/>
                                </Popconfirm>
                                : ""}
                        </>
                    }))
                );
                setLoading(false);
            }
        ).catch(
            error => {
                console.log(error)
            }
        );
    };

    const deleteRule = async (id) => {
        await deleteById(localStorage.getItem('token'), id).then(
            response => {
                getRules();
                if (response.data === true) {
                    setAlertSuccessVisible(true);
                }
            }).catch(
            error => {
                setAlertErrorVisible(true);
                console.log(error)
            }
        );
    };

    useEffect(() => {
        getRules();
    }, []);

    const handleSuccessClose = () => {
        setAlertSuccessVisible(false);
    };

    const handleErrorClose = () => {
        setAlertErrorVisible(false);
    };

    return (
        <div
            style={{
                minHeight: '100vh',
            }}
        >
            <Button onClick={goBack} style={{
                margin: '1vw',
            }}><LeftOutlined/> Назад</Button>
            <div
                style={{
                    minHeight: '100vh',
                    display: "flex",
                    justifyContent: "center"
                }}
            >
                <div
                    style={{}}
                >
                    <Divider>Наборы бонусных правил</Divider>
                    <Button onClick={() => navigate(`${ADD_BONUS_RULE_ROUTE}`)} style={{
                        margin: '1vw',
                        display: 'block'
                    }}>Добавить набор</Button>
                    {loading ? (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center"
                            }}
                        >
                            <Spin/>
                        </div>
                    ) : (
                        <Table
                            columns={rulesColumns}
                            dataSource={rules}
                            pagination={false}
                            bordered
                            scroll={{x: "max-content"}}
                            style={{
                                margin: '1vw',
                            }}
                        />
                    )}
                    {alertSuccessVisible && (
                        <Alert message="Успешно удалено" type="success" closable
                               afterClose={handleSuccessClose}
                               style={{marginTop: '1vw',}}/>
                    )}
                    {alertErrorVisible && (
                        <Alert message="Ошибка удаления" type="error" closable
                               afterClose={handleErrorClose}
                               style={{marginTop: '1vw',}}/>
                    )}
                </div>
            </div>
        </div>
    );
}